import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackingComponent } from './admin/pages/tracking/tracking.component';
import { TrackingDetailsComponent } from './admin/pages/tracking-details/tracking-details.component';

const routes: Routes = [
  { path: '', redirectTo: 'Homepage', pathMatch: 'full' },
  { path: 'Homepage', component: TrackingComponent },
  { path: 'track', component: TrackingDetailsComponent }, 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
